import { useEffect, useRef } from "react";

// Re-runs `fn` when the app regains focus/visibility and every `ms` while visible.
export function useLiveRefresh(fn, ms = 60000) {
    const ref = useRef(fn);
    ref.current = fn;
    useEffect(() => {
        const run = () => { if (document.visibilityState === "visible") ref.current(); };
        const t = setInterval(run, ms);
        document.addEventListener("visibilitychange", run);
        window.addEventListener("focus", run);
        return () => {
            clearInterval(t);
            document.removeEventListener("visibilitychange", run);
            window.removeEventListener("focus", run);
        };
    }, [ms]);
}
